import React from "react";
import type { FC } from "react";

import { Indicator } from "../../Indicator";

import type { IndicatorOnlineDefaultPresetProps } from "../types";

import classes from "./IndicatorOnlineDefaultPreset.styl";

const DEFAULT_PRESET_TEST_ID = "indicator-preset-test-id";

/**
 * Компоненты-пресеты на основе компонента Indicator.
 *
 * <a href="https://www.figma.com/design/vTg3KAvmAXA9LigeyiqCWL/%F0%9F%92%A0-Base-Components?m=auto&node-id=9799-415149" target="_blank">Все пресеты</a>
 */
export const IndicatorOnlineDefaultPreset: FC<
    IndicatorOnlineDefaultPresetProps
> = ({
    platform = "mob",
    "data-tsid": tsid = DEFAULT_PRESET_TEST_ID,
    ...restProps
}) => {
    const indicatorOnlineCustomColorsStyles = classes[`platform-${platform}`];

    return (
        <Indicator
            {...restProps}
            data-tsid={tsid}
            view="custom"
            customColorsStyles={indicatorOnlineCustomColorsStyles}
        />
    );
};
